import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=dff21c5c&scoped=true"
import script from "./footerNav.vue?vue&type=script&lang=js"
export * from "./footerNav.vue?vue&type=script&lang=js"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=dff21c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff21c5c",
  null
  
)

export default component.exports